import React, { useState } from 'react';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { removeDwUser } from '@/API/repositories/tickets';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import {
	DwListItem,
	DwListItemWrapper,
} from '@/pages/admin/infobar/components/ticket/components/conversationGroup/ConversationGroup.styled';
import { getUserName } from '@/pages/consultant/infobar/ticket/helpers/getUsername';
import { getUserById } from '@/pages/consultant/infobar/ticket/helpers/getUserById';
import Icon from '@/common/components/Icon';
import { Colors } from '@/common/colors/colors';

const DwItem = ({ user, loadData, selectedTicket }) => {
	const [dwRemoving, setDwRemoving] = useState();

	const { makeRequest } = useRequestsContext();
	const {
		commonData: { users },
	} = useCommonDataContext();

	const handleRemoveDw = async (userToRemove) => {
		setDwRemoving((prev) => [...(prev || []), userToRemove]);

		const response = await makeRequest(
			removeDwUser.bind(null, selectedTicket._id, userToRemove.value),
		);

		if (response.data) {
			await loadData();
		}

		setDwRemoving((prev) =>
			prev?.filter((user) => user.value !== userToRemove.value),
		);
	};

	return (
		<DwListItemWrapper>
			{getUserName(getUserById(user.value, users))}
			<DwListItem
				onClick={() => handleRemoveDw(user)}
				className='animation-scale'
			>
				<Icon
					name={
						dwRemoving?.find(
							(removingUser) => removingUser.value === user.value,
						)
							? 'spinner'
							: 'x'
					}
					size={14}
					color={Colors.red}
				/>
			</DwListItem>
		</DwListItemWrapper>
	);
};

export default DwItem;
